module.exports = __webpack_public_path__ + "static/media/banner-prezao-free-fire.3504ecdf.png";